import React from "react";
import { Link } from "react-router-dom";
import { remediesStoreItems } from "../data";

function RemediesSection() {
  return (
    <section className="remedies-store-section py-10 md:py-16 relative overflow-hidden">
      <div className="container">
        <div className="max-w-[950px] mx-auto text-center mb-8 md:mb-12">
          <span className="inline-flex items-center gap-2 tracking-[.2em] body-lg">
            <span className="w-[33px] h-[1px] bg-primary-500 inline-block"></span>
            REMEDIES STORE
          </span>
          <h2 className="web-h2 text-zinc-900 mt-3">
            Discover your spiritual essentials
          </h2>
          <p className="web-body-sm text-zinc-600 mt-2">
            Explore a thoughtfully presented collection of products inspired by
            astrology, spirituality and traditional practices.
          </p>
          <p className="web-body-sm text-zinc-600 mt-2">
            From gemstones and yantras to puja essentials, discover products
            that connect with your interests, beliefs and personal practices.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-[15px] md:gap-[30px]">
          {remediesStoreItems.map((item) => (
            <div
              key={item.id}
              className="flex flex-col items-center store-box gap-[15px]"
            >
              <img
                src={item.icon}
                alt={item.title}
                className="aspect-[10/11] object-cover rounded-[10px]"
              />
              <div className="web-h4">{item.title}</div>
            </div>
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <Link
            to="/remedies-store"
            className="custom-btn custom-btn-primary no-underline"
          >
            Explore the Collection
          </Link>
        </div>
      </div>
    </section>
  );
}

export default RemediesSection;
